<template>
  <validation-provider
    tag="div"
    :name="name || label"
    :vid="vid"
    v-slot="{ errors }"
    :rules="rules"
  >
    <label class="custom_input_label" v-if="label">
      {{ label }}
    </label>
    <v-text-field
      outlined
      dense
      class="number-input"
      v-on="{ ...$listeners, input: () => {} }"
      :value="value"
      v-bind="$attrs"
      @input="(val) => $emit('input', val)"
      :error-messages="errors[0]"
      v-currency-directive="options"
    >
    </v-text-field>
  </validation-provider>
</template>

<script>
import { CurrencyDirective } from "vue-currency-input";

export default {
  name: "number-input",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    vid: {
      type: String,
    },
    value: {},
    rules: {
      type: [Object, String, Boolean],
    },
    min: {
      type: Number,
      default: 0,
    },
    precision: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      options: {
        currency: null,
        valueRange: { min: this.min, max: this.max },
        precision: this.precision,
      },
    };
  },
  directives: {
    CurrencyDirective,
  },
  computed: {},
};
</script>
